import React from 'react';
import { makeClassName } from '@siteless/util';

const LaurelRightIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('LaurelRightIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M5.86,22.6c0.32,0,0.65-0.01,0.97-0.04c5.71-0.53,9.92-5.6,9.39-11.3C15.99,8.72,14.84,6.37,13,4.64
	c-0.2-0.19-0.52-0.18-0.71,0.02c-0.19,0.2-0.18,0.52,0.02,0.71c1.67,1.57,2.71,3.69,2.92,5.98c0.48,5.16-3.33,9.74-8.49,10.22
	c-0.5,0.05-1,0.05-1.49,0.02c-0.27-0.01-0.51,0.19-0.53,0.47c-0.02,0.28,0.19,0.51,0.47,0.53C5.41,22.59,5.64,22.6,5.86,22.6z"
    />
    <path
      d="M14.61,7.6c0.12,0,0.23-0.04,0.32-0.12c0.04-0.03,1.01-0.86,1.25-2.08c0.24-1.23-0.35-2.35-0.37-2.4
	c-0.07-0.13-0.2-0.23-0.35-0.26c-0.14-0.03-0.3,0.01-0.42,0.11C15,2.88,14.04,3.7,13.8,4.93c0,0,0,0,0,0
	c-0.24,1.23,0.35,2.35,0.37,2.4c0.07,0.13,0.2,0.23,0.35,0.26C14.54,7.6,14.58,7.6,14.61,7.6z M15.17,4.21
	c0.06,0.29,0.09,0.64,0.02,1c-0.07,0.35-0.23,0.67-0.4,0.91c-0.06-0.29-0.09-0.64-0.02-1C14.85,4.77,15.01,4.46,15.17,4.21z"
    />
    <path
      d="M15.93,12.59c0.03,0,0.07,0,0.1-0.01c0.05-0.01,1.29-0.27,2.09-1.24c0.8-0.97,0.82-2.24,0.82-2.29
	c0-0.15-0.07-0.29-0.18-0.39c-0.12-0.1-0.27-0.14-0.42-0.1c-0.05,0.01-1.29,0.27-2.09,1.24c-0.8,0.97-0.82,2.23-0.82,2.29
	c0,0.15,0.07,0.29,0.18,0.39C15.71,12.55,15.82,12.59,15.93,12.59z M17.81,9.82c-0.09,0.29-0.23,0.61-0.45,0.89
	c-0.23,0.28-0.52,0.48-0.78,0.61c0.09-0.29,0.23-0.61,0.45-0.89S17.54,9.96,17.81,9.82z"
    />
    <path
      d="M10.27,21.32c0.13,0,0.26-0.05,0.35-0.14c0.04-0.04,0.94-0.94,1.08-2.18c0.14-1.24-0.53-2.32-0.56-2.36
	c-0.08-0.13-0.22-0.21-0.37-0.23c-0.16-0.02-0.3,0.03-0.41,0.14c-0.04,0.04-0.94,0.94-1.08,2.18l0,0c-0.14,1.24,0.53,2.32,0.56,2.36
	c0.08,0.13,0.22,0.21,0.37,0.23C10.23,21.32,10.25,21.32,10.27,21.32z M10.6,17.9c0.08,0.29,0.14,0.63,0.1,0.99
	c-0.04,0.36-0.17,0.68-0.32,0.94c-0.08-0.29-0.14-0.63-0.1-0.99l0,0C10.32,18.48,10.45,18.16,10.6,17.9z"
    />
    <path
      d="M13.61,18.34c0.05,0,0.11-0.01,0.16-0.02c0.14-0.05,0.26-0.16,0.31-0.3c0.02-0.05,0.46-1.24,0.07-2.43
	c-0.39-1.19-1.45-1.89-1.5-1.91c-0.13-0.08-0.29-0.1-0.43-0.06c-0.14,0.05-0.26,0.16-0.31,0.3c-0.02,0.05-0.46,1.24-0.07,2.43
	c0,0,0,0,0,0c0.39,1.19,1.45,1.89,1.5,1.91C13.42,18.31,13.51,18.34,13.61,18.34z M12.69,15.04c0.2,0.23,0.39,0.52,0.51,0.86
	c0.11,0.34,0.12,0.69,0.1,0.99c-0.2-0.23-0.39-0.52-0.51-0.86C12.68,15.69,12.67,15.34,12.69,15.04z M12.32,16.19L12.32,16.19
	L12.32,16.19z"
    />
    <path
      d="M15.41,14.03c0.05-0.02,0.09-0.05,0.14-0.08c0.12-0.1,0.18-0.24,0.18-0.39c0-0.05-0.04-1.32-0.84-2.28
	c-0.8-0.96-2.05-1.21-2.1-1.22c-0.15-0.03-0.3,0.01-0.42,0.11c-0.12,0.1-0.18,0.24-0.18,0.39c0,0.05,0.04,1.32,0.84,2.28
	c0,0,0,0,0,0c0.81,0.96,2.05,1.21,2.1,1.22C15.22,14.08,15.32,14.07,15.41,14.03z M13.33,11.32c0.27,0.14,0.56,0.33,0.79,0.61
	c0.23,0.27,0.37,0.6,0.46,0.88c-0.27-0.14-0.56-0.33-0.79-0.61C13.56,11.92,13.41,11.6,13.33,11.32z"
    />
    <path
      d="M13.2,9.62c0.97,0,1.75-0.41,1.79-0.43c0.13-0.07,0.23-0.2,0.26-0.35c0.03-0.15-0.01-0.3-0.11-0.42
	c-0.04-0.04-0.86-1.01-2.08-1.25c0,0,0,0,0,0c-1.22-0.24-2.35,0.34-2.4,0.37c-0.13,0.07-0.23,0.2-0.26,0.35
	c-0.03,0.15,0.01,0.3,0.11,0.42c0.04,0.04,0.86,1.01,2.08,1.25C12.79,9.6,13,9.62,13.2,9.62z M13.77,8.55
	c-0.29,0.06-0.64,0.09-1,0.02c-0.35-0.07-0.67-0.23-0.91-0.4c0.29-0.06,0.64-0.09,1-0.02C13.21,8.23,13.52,8.39,13.77,8.55z"
    />
    <path
      d="M14.75,17.66c-0.25-0.08-0.4-0.35-0.33-0.61c0.07-0.27,0.35-0.42,0.62-0.35c0.01,0,0.94,0.25,1.76-0.1
	c0.33-0.14,0.6-0.36,0.81-0.58c-0.3,0-0.65,0.05-0.98,0.19c-0.25,0.11-0.55-0.01-0.66-0.26c-0.11-0.25,0.01-0.55,0.26-0.66
	c1.15-0.49,2.37-0.16,2.42-0.14c0.17,0.05,0.27,0.15,0.32,0.28c0.06,0.14,0.05,0.3-0.02,0.43c-0.02,0.05-0.62,1.17-1.77,1.66
	c-1.15,0.49-2.37,0.16-2.43,0.14C14.76,17.66,14.76,17.66,14.75,17.66z"
    />
    <path
      d="M13.89,22.04c1.09,0,1.97-0.55,2.01-0.58c0.13-0.08,0.21-0.21,0.23-0.37c0.02-0.15-0.04-0.3-0.14-0.41
	c-0.04-0.04-0.93-0.94-2.18-1.08l0,0c-1.25-0.15-2.32,0.53-2.36,0.56c-0.13,0.08-0.21,0.21-0.23,0.37c-0.02,0.15,0.04,0.3,0.14,0.41
	c0.04,0.04,0.93,0.94,2.18,1.08C13.66,22.03,13.77,22.04,13.89,22.04z M14.64,20.93c-0.29,0.08-0.63,0.14-0.99,0.1
	c-0.36-0.04-0.68-0.18-0.94-0.32c0.29-0.08,0.64-0.14,0.99-0.1C14.06,20.64,14.38,20.78,14.64,20.93z"
    />
    <path
      d="M12.64,5.51c0.04,0,0.06,0,0.06,0c0.15-0.01,0.29-0.08,0.38-0.2c0.09-0.12,0.12-0.28,0.08-0.42
	c-0.01-0.05-0.34-1.28-1.34-2.03c-1-0.75-2.28-0.71-2.33-0.71c-0.15,0.01-0.29,0.08-0.38,0.2C9.03,2.48,9,2.63,9.04,2.78
	c0.01,0.05,0.34,1.28,1.34,2.03l0,0C11.27,5.47,12.36,5.51,12.64,5.51z M10.33,3.25c0.29,0.07,0.62,0.2,0.91,0.41
	c0.29,0.21,0.5,0.49,0.65,0.75c-0.29-0.07-0.62-0.2-0.91-0.41l0,0C10.69,3.79,10.48,3.51,10.33,3.25z"
    />
  </svg>
);

export default LaurelRightIcon;
